// extracted by mini-css-extract-plugin
module.exports = {"body-wrapper":"ModalCreateRequest_body-wrapper__2DN2d","icon":"ModalCreateRequest_icon__3QVeo","button-wrapper":"ModalCreateRequest_button-wrapper__1dTft"};